const CMN_addXMLRequestCallback = (callback) => {
    var oldSend, i;
    if (XMLHttpRequest.callbacks) {
        XMLHttpRequest.callbacks.push(callback);
    } else {
        XMLHttpRequest.callbacks = [callback];
        oldSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            if (XMLHttpRequest.callbacks != undefined || XMLHttpRequest.callbacks != null) {
                for (i = 0; i < XMLHttpRequest.callbacks.length; i++) {
                    XMLHttpRequest.callbacks[i](this);
                }
            }
            oldSend.apply(this, arguments);
        }
    }
}

/***** This function is executed after item is added to cart *****/
const afterCartAdded = () => {
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Assuming the response is JSON
  })
  .then(data => {
    // Work with the data
    if(data.item_count > 0){
      let __totalItems = data.item_count;
      let __totalPrice = Shopify.formatMoney(data.total_price);
      if(document.querySelector(".cart__popup_count")){        
        document.querySelector(".cart__popup_count").innerText = __totalItems +' Item';
      }
      if(document.querySelector(".cart_popup_price")){        
        document.querySelector(".cart_popup_price").innerText = __totalPrice;
      }
      let __cartcount = document.querySelectorAll(".header__cart__status")
      __cartcount.forEach(selec=>{
        selec.innerText = __totalItems;
        selec.setAttribute("data-cart-count",__totalItems);
      })
      if(document.querySelector(".cart__popup_main")){        
        document.querySelector(".cart__popup_main").style.display="block"
      }
      if(document.querySelector(".cart__items_count_price")){        
        document.querySelector(".cart__items_count_price").style.display="block"
      }
      setTimeout(function(){
       	 if(document.querySelector(".cart__popup_main")){        
          document.querySelector(".cart__popup_main").style.display="none"
          }
      }, 2000); //Time before execution
    }
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
};
/***** This function is executed after item is added to cart *****/

/**** XHR requests handler ****/
CMN_addXMLRequestCallback(function (xhr) {
    xhr.addEventListener("load", function () {
        let __status = xhr.status;
        if (__status === 0 || (__status >= 200 && __status < 400) && xhr.hasOwnProperty("_url")) {

            if (xhr._url.indexOf("/cart/add.js") !== -1) {
                afterCartAdded()
            }
        }
    });
});
/**** XHR requests handler ****/

/**** Fetch requests handler ****/
(function (ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function () {
        var out = fetch.apply(this, arguments);
        var __badRequest = true;
        out.then(response => {
            let __status = response.status;
            if (__status !== 0 || (__status >= 200 && __status < 400)) {
                __badRequest = false;
            }
            if (__status >= 400) {
                return false;
            }
            if (response.headers.get("content-type") !== null) {
                if (response.headers.get("content-type").includes("application/json") || response.headers.get("content-type").includes("text/javascript")) {
                    return response.clone().json();
                }
                else {
                    return response;
                }
            }
        }).then(data => {
            if (__badRequest) {
                return false;
            }
            if (data === undefined || typeof data === "undefined") {
                return out;
            }
            if (typeof arguments[0] == 'string') {
                if (arguments[0].indexOf("/cart/add") !== -1) {
                    afterCartAdded()
                }
            }
        });
        return out;
    }
}(window, window.fetch));
/**** Fetch requests handler ****/